// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-5f1d2d90] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.info[data-v-5f1d2d90] .el-table .el-table__header .el-table__cell {\n    padding: 0;\n}\n.info[data-v-5f1d2d90] .el-table .el-table__row .el-table__cell {\n    color: #303033;\n    font-weight: 400;\n}\n", ""]);
// Exports
module.exports = exports;
